import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Alert,
  Input,
  FormLabel,
} from '@mui/joy';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import SeoHelmet from "../components/SeoHelmet";
import i18n from '../i18n';

const SetGender = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const [babyName, setBabyName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleConfirm = async () => {
    if (!selected) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://revealoo.com/api/set_gender.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          eventId: id,
          gender: selected,
          baby_name: babyName || undefined,
        }),
      });

      const data = await res.json();
      if (data.success) {
  setSuccess(true);
  setTimeout(() => {
    const lang = i18n.language; // bierze aktualnie ustawiony język
    navigate(`/${lang}/c/${id}`);
  }, 2000);
} else {
        setError(data.error || t('setGender.errorGeneric'));
      }
    } catch {
      setError(t('setGender.errorConnection'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 410,
        mx: 'auto',
        mt: { xs: 4, md: 6 },
        px: { xs: 1.5, sm: 3 },
        py: { xs: 2, sm: 3 },
        background: '#fff',
        borderRadius: '22px',
        boxShadow: '0 4px 24px 2px #e9eaf7b0',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <Typography
        level="h2"
        sx={{
          fontSize: { xs: '1.3rem', sm: '1.7rem' },
          mb: { xs: 2, sm: 3 },
          fontWeight: 800,
          letterSpacing: '0.01em',
          color: '#2d3c88',
        }}
        gutterBottom
      >
        {/* Tu obsługa <b>...<b> przez Trans */}
        <Trans i18nKey="setGender.title" components={{ b: <b /> }} />
      </Typography>

      {/* FLEX row dla kart */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          justifyContent: 'center',
          alignItems: 'center',
          mb: { xs: 2.5, sm: 3.5 },
        }}
      >
        {/* Dziewczynka */}
        <Card
          variant={selected === 'girl' ? 'solid' : 'outlined'}
          color="danger"
          onClick={() => setSelected('girl')}
          sx={{
            cursor: 'pointer',
            flex: 1,
            minWidth: 120,
            maxWidth: 180,
            height: 90,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'box-shadow .16s, border .16s',
            borderWidth: selected === 'girl' ? 2 : 1,
            boxShadow: selected === 'girl' ? '0 4px 16px 2px #f8bbd044' : 'none',
            outline: selected === 'girl' ? '2px solid #ec407a88' : 'none',
            background: selected === 'girl' ? '#fff0f6' : '#fff',
            '&:hover': {
              boxShadow: '0 4px 20px 2px #f8bbd044',
              borderColor: '#f06292',
            },
          }}
        >
          <CardContent
            sx={{
              px: 0,
              py: 0,
              width: '100%',
              textAlign: 'center',
              fontWeight: 700,
              fontSize: '1.16rem',
              color: selected === 'girl' ? '#e91e63' : '#ba4079',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <span style={{ fontSize: 30, marginBottom: 2 }}>👧</span>
            {t('setGender.girl')}
          </CardContent>
        </Card>
        {/* Chłopiec */}
        <Card
          variant={selected === 'boy' ? 'solid' : 'outlined'}
          color="primary"
          onClick={() => setSelected('boy')}
          sx={{
            cursor: 'pointer',
            flex: 1,
            minWidth: 120,
            maxWidth: 180,
            height: 90,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'box-shadow .16s, border .16s',
            borderWidth: selected === 'boy' ? 2 : 1,
            boxShadow: selected === 'boy' ? '0 4px 16px 2px #bbdefb44' : 'none',
            outline: selected === 'boy' ? '2px solid #2196f388' : 'none',
            background: selected === 'boy' ? '#e3f2fd' : '#fff',
            '&:hover': {
              boxShadow: '0 4px 20px 2px #bbdefb44',
              borderColor: '#1976d2',
            },
          }}
        >
          <CardContent
            sx={{
              px: 0,
              py: 0,
              width: '100%',
              textAlign: 'center',
              fontWeight: 700,
              fontSize: '1.16rem',
              color: selected === 'boy' ? '#1976d2' : '#4976b8',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <span style={{ fontSize: 30, marginBottom: 2 }}>👦</span>
            {t('setGender.boy')}
          </CardContent>
        </Card>
      </Box>

      {/* Nazwa dziecka */}
      <FormLabel
        sx={{
          display: 'block',
          mb: 1,
          mt: { xs: 2.5, sm: 3.5 },
          textAlign: 'left',
          fontWeight: 500,
          color: '#6075b3',
        }}
      >
        {/* Tu obsługa <span class="gray"> przez Trans */}
        <Trans i18nKey="setGender.nameLabel" components={{ span: <span className="gray" /> }} />
      </FormLabel>
      <Input
        placeholder={t('setGender.namePlaceholder')}
        value={babyName}
        onChange={(e) => setBabyName(e.target.value)}
        sx={{
          mb: 2,
          width: '100%',
          background: '#f7f8fa',
          borderRadius: '11px',
          fontSize: '1rem',
          py: 1.3,
        }}
      />

      <Button
        sx={{
          mt: 2,
          mb: 1,
          borderRadius: '11px',
          width: '100%',
          fontSize: '1.07rem',
          fontWeight: 700,
          boxShadow: '0 2px 10px #e6f0fd33',
          py: 1.5,
        }}
        disabled={!selected || loading}
        color={selected === 'girl' ? 'danger' : 'primary'}
        onClick={handleConfirm}
      >
        {loading ? t('setGender.saving') : t('setGender.confirm')}
      </Button>

      {error && (
        <Alert variant="soft" color="danger" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert variant="soft" color="success" sx={{ mt: 2 }}>
          {t('setGender.saved')}
        </Alert>
      )}
    </Box>
  );
};

export default SetGender;
